<script>
import {
    mapGetters
} from 'vuex';
export default {
    name: 'CompetenceCardsBatchDataProvider',
    computed: mapGetters('competences', {
		batchCompetenceCardRows: 'batchCompetenceCardRows',
		loading: 'loading',
		courseOptions: 'courseOptions',
		competenceCards: 'competenceCards',
	}),
	data() {
		return {
			showBatchSuccessMessage: false
		}
	},
	methods: {
		batchAddCourse({ competenceCards, category, courseType, name, issuer, issued, expires, printOption }) {
			this.$store.dispatch('competences/batchAddCourse', {
				competenceCards: competenceCards,
				categoryGroup: category.group,
				category: category.name,
				courseType,
				name,
				issuer,
				issued,
				expires,
				printOption
			}).then(success => {
				this.showBatchSuccessMessage = success;
            });
		},
		toggleBatchSuccessMessage() {
			this.showBatchSuccessMessage = !this.showBatchSuccessMessage;
		}
	},
    render() {
        if (!this.$scopedSlots.default) {
            return;
        }

        const slotScope = {
			loading: this.loading,
			batchCompetenceCardRows: this.batchCompetenceCardRows,
			competenceCards: this.competenceCards,
			courseOptions: this.courseOptions,
			batchAddCourse: this.batchAddCourse,
			showBatchSuccessMessage: this.showBatchSuccessMessage,
			toggleBatchSuccessMessage: this.toggleBatchSuccessMessage
		};
		
        return this.$scopedSlots.default(slotScope);
    },
    created() {
		if(!this.competenceCards || this.competenceCards.length === 0) {
			this.$store.dispatch('competences/fetchCompetenceCards');
		}
	}
}
</script>
